/**
   This mixin has a dependency from the class.
   The class is required to have a computed
   property called `selectBalanceDocumentModel`.
   It must return the object in which we are goind to
   operate on.
 */
import { formatDDMMYYYYToIsoDate } from "@/utils/formats.js";
export default {
  data() {
    return {
      isBalanceModalOpen: false,
      balanceFormErrors: [],
      formatDDMMYYYYToIsoDate
    };
  },
  computed: {
    validateBalanceDocuments() {
      return this.selectBalanceDocumentModel.documents.length > 0;
    }
  },
  methods: {
    checkBalanceDocumentsErrors() {
      this.validateBalanceDocuments && (this.balanceFormErrors = []);
    },
    onToggleBalanceModal() {
      this.isBalanceModalOpen = !this.isBalanceModalOpen;
    },
    onCompletedBalanceDocumentSelection() {
      this.checkBalanceDocumentsErrors();
      this.onToggleBalanceModal();
    },
    onSelectedBalanceDocuments(documents) {
      const useModel = this.selectBalanceDocumentModel;
      const startDate = `${documents[0].inicio.split("/")[1]}-${
        documents[0].inicio.split("/")[2]
      }`;
      const endDate = `${documents[0].fim.split("/")[1]}-${
        documents[0].fim.split("/")[2]
      }`;
      documents[0].arquivo.nome = `Balanço (${startDate}|${endDate})`;
      documents[0].inicio = this.formatDDMMYYYYToIsoDate(documents[0].inicio);
      documents[0].fim = this.formatDDMMYYYYToIsoDate(documents[0].fim);
      useModel.documents = useModel.documents.concat(documents);
    },
    onRemoveFile(document) {
      const useModel = this.selectBalanceDocumentModel;
      useModel.documents = useModel.documents.filter(
        doc => doc.arquivo.nome !== document.arquivo.nome
      );
    }
  }
};
